/*
 * @Author: wangxiang
 * @Date: 2019-11-24 15:53:45
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-02 21:44:53
 */
export default {
  routes: [
    {
      path: '/aienroll',
      name: 'aienroll',
      component: () => import('@/module/aiEnroll/Activity.vue'),
      meta: {
        title: 'AI招生',
        keepAlive: false,
        logined: false
      }
    },
    // {
    //   path: '/activity/detail',
    //   name: 'detailresult',
    //   component: () => import('@/module/aiEnroll/ShortResult.vue'),
    //   meta: {
    //     title: '报告详情',
    //     keepAlive: false,
    //     logined: false
    //   }
    // },
    {
      path: '/activity/short',
      name: 'shortreport',
      component: () => import('@/module/aiEnroll/ShortResult.vue'),
      meta: {
        title: '报告详情',
        keepAlive: false,
        logined: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/AIEnroll.js